import React from 'react';
import './styles/ActiveFilterChips.css';
const ActiveFilterChips = ({
  
  
  groupFilter,
  subgroupFilter,
  zoneFilter,
  techFilter,serviceFilter,brandFilter,
  onRemoveFilter
}) => {

  const getFilterValue = (filterType, filterData) => {
    // Si es un array y tiene más de 2 elementos, acorta el texto para mostrar en el chip
    if (Array.isArray(filterData) && filterData.length > 2) {
      const firstTwo = filterData.slice(0, 2);
      const remainingCount = filterData.length - 2;
      // Maneja la etiqueta si el array es de objetos
      if (['tech', 'group','subgroup', 'zone','service','brand'].includes(filterType)) {
        return `${firstTwo.map(item => item.label).join(', ')}... (+${remainingCount})`;
      }

      return `${firstTwo.join(', ')}... (+${remainingCount})`;
    }

    // Lógica original para otros casos
    switch (filterType) {
      case 'ack':
        return filterData.map(item => item ? 'Con Ack' : 'Sin Ack').join(', ');
      case 'ticket':
        return filterData.map(item => item ? 'Con Ticket' : 'Sin Ticket').join(', ');
      case 'severity':
        // return filterData.join(', ');
return  filterData.map(item => item==6?'ODD':item).join(', ');

      case 'status':
        return filterData.join(', ');
      case 'tipo':
        return filterData.join(', ');
      case 'tech':
         case 'service':
         case 'brand':
          
      case 'group':
        case 'subgroup':
      case 'zone':
        return filterData.map(item => item.label).join(', ');
      default:
        return '';
    }
  };

  const getFullFilterValue = (filterType, filterData) => {
    if (Array.isArray(filterData)) {
        // Usa el 'label' si es un array de objetos
        if (['tech', 'group','subgroup', 'zone','service','brand'].includes(filterType)) {
            return filterData.map(item => item.label).join(', ');
        }
         if (['ticket', 'ack'].includes(filterType)) {
            return filterData.map(item => item ? (filterType==='ack'?'Con Ack':'Con Ticket') : (filterType==='ack'?'Sin Ack':'Sin Ticket')).join(', ');
        }
         if (['severity'].includes(filterType)) {
            return filterData.map(item => item==6?'ODD':item).join(', ')
        }
        // Para arrays de strings o números, simplemente une los valores
        return filterData.join(',  ');
    }
    // Para valores booleanos como 'ack' y 'ticket'
    return getFilterValue(filterType, filterData);
  };
  
  const renderChip = (filterType, filterData) => {
  if (
    (Array.isArray(filterData) && filterData.length > 0) ||
    (filterData !== null && !Array.isArray(filterData))
  ) {
    return (
      <div className="active-filter-chip">
        {getFilterLabel(filterType)}: {getFilterValue(filterType, filterData)}
        <span
          className="remove-filter"
          onClick={() => onRemoveFilter(filterType)}
        >
          &times;
        </span>
        {/* Aquí se añade el tooltip personalizado */}
        <div className="chip-tooltip">
          {getFullFilterValue(filterType, filterData)}
        </div>
      </div>
    );
  }
  return null;
};

  const getFilterLabel = (filterType) => {
    switch (filterType) {
      case 'service':
        return 'Servicios';
      case 'brand':
        return 'Marcas';
      case 'severity':
        return 'Severidad';
      case 'tech':
        return 'Tecnologías';
      case 'group':
        return 'Grupos';
      case 'subgroup':
        return 'Subgrupos';
      case 'zone':
        return 'Zonas';
      case 'ack':
        return 'Ack';
      case 'ticket':
        return 'Ticket';
      case 'tipo':
        return 'Tipo';
      default:
        return '';
    }
  };

  return (
    <div className="active-filters">
      {renderChip('service', serviceFilter)}
      {renderChip('brand', brandFilter)}
      {renderChip('group', groupFilter)}
      {renderChip('subgroup', subgroupFilter)}
      {renderChip('zone', zoneFilter)}
    </div>
  );
};

export default ActiveFilterChips;